import {get} from 'lodash';

export default (state = {}, {candidateId, stateName, stateValue}: any) => {
  return {
    ...state,
    allCandidatesState: {
      ...get(state, 'allCandidatesState', {}),
      [candidateId]: {
        ...get(state, `allCandidatesState.${candidateId}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
